/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { _t } from 'app/utils/i18n';
import { TInfIds } from 'app/utils/types';
import {
  getInfTweetsFilters,
  getInfTweetsInfoFromSlug,
} from 'reports/utils/influencer-tweet-handlers';
export const tweetColumn = 'tweetColumn';
export const infInfo = 'inf_info';
export const ALL = 'ALL';
export const employeesSlug = 'influencers_linkedin_employees_column';
export const jobsSlug = 'influencers_linkedin_jobs_column';
export const alumniSlug = 'influencers_linkedin_alumni_column';
export const studentsSlug = 'influencers_linkedin_students_column';
export const templateTypes = [
  { label: _t('reports:single'), value: 'REPORT' },
  { label: _t('reports:compare'), value: 'COMPARE' },
];
export const isInfluencer = (): boolean =>
  window.location.pathname.includes('INFLUENCERS') ||
  window.location.pathname.includes('ENTITIES');
export const constants = {
  structureElement: 'struct',
  paragraphElement: 'paragraph',
  titleElement: 'title',
  subTitleElement: 'sub_title',
  reportNameElement: 'report_name',
  generalElement: 'comp',
  componentsHelper: 'template-charts-options',
  structureHelper: 'template-charts-structure',
  templateComps: 'template-comps',
  influencerInformation: 'influencers_information',
  pageBreakerElement: 'page_breaker',
  newsArticles: 'news_articles',
};
export const isSlugInfRelation = (slug: string): boolean => {
  if (
    slug?.includes('influencers_related_influencers') ||
    slug?.includes('influencers_related_entities')
  ) {
    return true;
  }
  return false;
};
export const isSlugEntityLinkedIn = (slug: string): boolean => {
  if (
    slug?.includes('influencers_linkedin_jobs_column') ||
    slug?.includes('influencers_linkedin_employees_column') ||
    slug?.includes('influencers_linkedin_alumni_column') ||
    slug?.includes('influencers_linkedin_students_column')
  ) {
    return true;
  }
  return false;
};
export const getCompBasedOnTabs = (
  type: string,
  allComps: any[],
  values?: any,
  isHashtag?: boolean,
): any[] => {
  const components: any[] = [];
  if (type === constants.generalElement) {
    allComps.forEach((comp) => {
      if (
        !comp?.slug?.includes(youtube) &&
        !comp?.slug?.includes(author) &&
        !comp?.slug?.includes(twitter) &&
        !comp?.slug?.includes(linkedin) &&
        !comp?.slug?.includes(news) &&
        !comp?.slug?.includes(instagram) &&
        !comp?.slug?.includes(tweets) &&
        !comp?.slug?.includes(posts_instagram) &&
        !comp?.slug?.includes(tiktok)
        /*  !comp?.slug?.includes('hashtags') */
      ) {
        components.push(comp);
      }
    });
  }
  if (type === twitter) {
    allComps.forEach((comp) => {
      if (
        comp.slug &&
        !comp?.slug?.includes(constants.influencerInformation) &&
        !isSlugInfRelation(comp?.slug) &&
        twitter &&
        comp?.type !== 'COMPARE'
      ) {
        getCompPlatform(comp?.slug) === twitter && components.push(comp);
      } else if (values?.['templatetype'] === 'REPORT' && isHashtag) {
        getCompPlatform(comp?.slug) === twitter &&
          comp?.type === 'REPORT' &&
          components.push(comp);
      } else {
        getCompPlatform(comp?.slug) === twitter &&
          comp?.type === 'COMPARE' &&
          components.push(comp);
      }
    });
  }
  if (type === 'hashtags') {
    allComps.forEach((comp) => {
      if (values?.['templatetype'] === 'REPORT') {
        comp?.type === 'REPORT' && components.push(comp);
      } else {
        comp?.type === 'COMPARE' && components.push(comp);
      }
    });
  }
  if (type === youtube) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === youtube && components.push(comp);
    });
  }
  if (type === linkedin) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === linkedin && components.push(comp);
    });
  }
  if (type === instagram) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === instagram && components.push(comp);
    });
  }

  if (type === tiktok) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === tiktok && components.push(comp);
    });
  }
  if (type === author) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === author && components.push(comp);
    });
  }
  if (type === news) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === news && components.push(comp);
    });
  }
  if (type === tweets) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === tweets && components.push(comp);
    });
  }
  if (type === posts_instagram) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === posts_instagram && components.push(comp);
    });
  }
  if (type === posts_linkedin) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === posts_linkedin && components.push(comp);
    });
  }
  if (type === posts_youtube) {
    allComps.forEach((comp) => {
      getCompPlatform(comp?.slug) === posts_youtube && components.push(comp);
    });
  }
  return components;
};
export const checkIfComponentOrTitle = (slug: string): boolean => {
  if (!slug) return false;
  if (
    !slug?.includes(constants.paragraphElement) &&
    !slug?.includes(constants.titleElement) &&
    !slug?.includes(constants.reportNameElement) &&
    !slug?.includes(constants.subTitleElement) &&
    !slug?.includes(constants.pageBreakerElement)
  )
    return true;
  return false;
};
export const twitter = 'twitter',
  author = 'author',
  youtube = 'youtube',
  linkedin = 'linkedin',
  news = 'news',
  instagram = 'instagram',
  tweets = 'tweets',
  tiktok = 'tiktok',
  posts_instagram = 'posts_instagram',
  posts_linkedin = 'posts_linkedin',
  posts_youtube = 'posts_youtube';
export const getCompPlatform = (slug: string): string => {
  return slug?.startsWith(news)
    ? news
    : slug?.includes(author) && !slug?.includes(posts_instagram)
      ? author
      : slug?.includes(youtube) && !slug?.includes(posts_youtube)
        ? youtube
        : slug?.includes(linkedin) && !slug?.includes(posts_linkedin)
          ? linkedin
          : slug?.includes(instagram) && !slug?.includes(posts_instagram)
            ? instagram
            : slug?.includes(tiktok)
              ? tiktok
              : slug?.includes(tweets) && !slug?.includes(twitter)
                ? /* !slug?.includes('hashtags') */
                  tweets
                : slug?.includes(posts_instagram)
                  ? posts_instagram
                  : slug?.includes(posts_linkedin)
                    ? posts_linkedin
                    : slug?.includes(posts_youtube)
                      ? posts_youtube
                      : twitter;
};
export const isNumber = (arg: unknown): boolean =>
  typeof arg === 'number' ? true : false;
export const getUniqueNameBasedOnPlatform = (
  comp: any,
  isHashtag?: boolean,
): string => {
  const platform = getCompPlatform(comp?.slug);
  if (platform === author) {
    return `${comp?.slug}--${comp?.item_count}`;
  }
  const item_sort_type_id = isNumber(comp?.item_sort_type_id)
    ? comp?.item_sort_type_id
    : comp?.item_sort_type_id?.sort_colum;
  if (platform === youtube) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${item_sort_type_id}`;
  }
  if (isHashtag) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${comp?.item_sort_type_id}--${comp?.item_view}`;
  }
  if (platform === linkedin) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${
      isNumber(comp?.post_type_id)
        ? comp?.post_type?.value
        : comp?.post_type_id?.value
    }${item_sort_type_id}`;
  }
  if (platform === instagram) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${
      isNumber(comp?.instagram_post_type_id)
        ? comp?.instagram_post_type?.value
        : comp?.instagram_post_type_id?.value
    }${item_sort_type_id}`;
  }
  if (platform === tweets) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${comp?.item_sort_type_id}--${comp?.item_view}`;
  }
  if (platform === posts_instagram || platform === posts_linkedin || platform === posts_youtube) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${comp?.item_sort_type_id}`;
  }
  if (platform === tiktok) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${
      isNumber(comp?.item_sort_type_id)
        ? comp?.item_sort_type_id
        : comp?.item_sort_type_id?.value
    }`;
  }
  if (platform === twitter && !isHashtag) {
    return `${comp?.slug}--${comp?.item_count}--${comp?.sort_type}--${
      isNumber(comp?.tweet_type_id)
        ? comp?.tweet_type?.value
        : comp?.tweet_type_id?.value
    }--${item_sort_type_id}--${comp?.item_view}`;
  }
  return '';
};

export const getInfSlugTab = (slug: string): string => {
  const tab =
    slug?.includes(twitter) || slug?.includes(tweets)
      ? _t('basic:twitter')
      : slug?.includes(author)
        ? _t('news:author')
        : slug?.includes(youtube)
          ? _t('basic:youtube')
          : slug?.includes(linkedin)
            ? _t('basic:linkedin')
            : slug?.includes(instagram)
              ? _t('basic:instagram')
              : slug?.includes(tiktok)
                ? _t('basic:tiktok')
                : slug?.includes(news)
                  ? _t('news:news')
                  : '';
  return tab;
};

export const numberOptionS = (platform: string) => {
  const checkIsJobsOrEmployees =
    platform === _t('entities:jobs') ||
    platform === _t('entities:employees') ||
    platform === _t('entities:alumni') ||
    platform === _t('entities:students')
      ? platform
      : _t(`reports:${platform}_item`);
  return [
    {
      label: `10 ${checkIsJobsOrEmployees} (${_t('basic:default')})`,
      value: '10', // first item is the deafult
    },
    {
      label: `20 ${checkIsJobsOrEmployees}`,
      value: '20',
    },
    {
      label: `30 ${checkIsJobsOrEmployees}`,
      value: '30',
    },
    {
      label: `40 ${checkIsJobsOrEmployees}`,
      value: '40',
    },
    {
      label: `50 ${checkIsJobsOrEmployees}`,
      value: '50',
    },
  ];
};

export const sortOptions = [
  {
    label: `${_t('basic:descending')} (${_t('basic:default')})`,
    value: 'desc',
  },
  {
    label: `${_t('basic:ascending')}`,
    value: 'asc',
  },
];

export const displayFormatOptions = [
  {
    label: `${_t('basic:list_view')} (${_t('basic:default')})`,
    value: 'LIST',
  },
  {
    label: `${_t('reports:table_view')}`,
    value: 'TABLE',
  },
];

const getInfIdBasedOnPlatform = (
  slug: string,
  influencer_ids: TInfIds,
): number => {
  const PLATFORMS = ['twitter', 'youtube', 'author', 'linkedin'];
  const platform = PLATFORMS.filter((platform) => slug.includes(platform))[0];
  return influencer_ids?.[platform];
};

export const getTabNameFromSlug = (slug: string) => {
  let tabName;
  if (slug?.includes('tweets')) tabName = 'TWEETS';
  if (slug?.includes('quotes')) tabName = 'QUOTES';
  if (
    slug?.includes('replies') ||
    (slug?.includes('replies') && slug?.includes('instagram'))
  )
    tabName = 'REPLIES';
  if (slug?.includes('instagram') && !slug?.includes('replies'))
    tabName = 'POSTS_INSTA';
  if (slug?.includes('linkedin')) tabName = 'POSTS';
  if (slug?.includes('youtube') || slug?.includes('tiktok')) tabName = 'VIDEOS';
  if (slug?.includes('comments')) tabName = 'COMMENTS';
  return tabName;
};

export const renderTweets = (
  selected_slugs: [],
  isInfluencerModule: boolean,
  influencer_ids: TInfIds,
  filters = {},
) => {
  const tweetColumns = selected_slugs
    ?.filter((chart: any) => chart?.chart_type === tweetColumn)
    .map((item: any, index) => ({
      type: getInfTweetsInfoFromSlug(item.slug, isInfluencerModule)?.type,
      requestUrl: getInfTweetsInfoFromSlug(
        item.slug,
        isInfluencerModule,
        item?.slug?.includes('hashtags'),
        item?.slug?.includes('posts'),
      )?.requestUrl,
      hideSort: true,
      tabName: getTabNameFromSlug(item?.slug),
      isReport: true,
      customFilters: {
        ...filters,
        influencer_id: isNumber(influencer_ids)
          ? influencer_ids
          : getInfIdBasedOnPlatform(item.slug, influencer_ids),
        limit: item?.item_count,
        type:
          item?.slug?.includes('posts') && item?.slug?.includes('replies')
            ? 'REPLY'
            : 'COMMENT',
        order_column: isNumber(item?.item_sort_type_id)
          ? item?.item_sort_type?.sort_colum
          : item?.item_sort_type_id?.sort_colum,
        type_of_sort: item?.sort_type,
        tweet_type: isNumber(item?.tweet_type_id)
          ? item?.tweet_type?.value
          : item?.tweet_type_id?.value,
        post_type: item?.slug?.includes('instagram')
          ? item?.instagram_post_type?.value
          : item?.slug?.includes('linkedin')
            ? item?.post_type?.value
            : item?.post_type_id?.value,
        ...getInfTweetsFilters(item),
        tweet_ids: item?.slug?.includes('twitter') ? item?.report_item_ids : [],
        video_ids: item?.slug?.includes('youtube') ? item?.report_item_ids : [],
        post_ids:
          item?.slug?.includes('instagram') ||
          item?.slug?.includes('linkedin') ||
          item?.slug?.includes('tiktok')
            ? item?.report_item_ids
            : [],
        article_ids: item?.slug?.includes('author')
          ? item?.report_item_ids
          : [],
      },
      id: `${item?.slug}_${index + 1}`,
    }));
  console.log(tweetColumns);
  return tweetColumns;
};

export const ArticlesOptions = () => {
  const title = _t('news:articles');
  return [
    {
      label: `5 ${title}`,
      value: '5',
    },
    {
      label: `10 ${title}`,
      value: '10',
    },
    {
      label: `15 ${title}`,
      value: '15',
    },
    {
      label: `20 ${title}`,
      value: '20',
    },
  ];
};
